import React, { useEffect, useMemo, useRef, useState } from "react";
import { useIntl } from "react-intl";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import { manageMeasures } from "./utils";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { clone, isEmpty, isNil } from "ramda";
import { ErrorText } from "./styled";
import { getMuiTheme, validateEmail, validatePassword } from "../../../../utils/utils";
import { ThemeProvider } from "styled-components";
import palette from "../../../../../config/colorPalette";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { toast } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker, LoadingButton } from "@mui/lab";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, startOfDay } from "date-fns";
import { postDoBData } from "../../../../api";

const AssetInfoForm = ({
  assetName,
  setAssetName,
  zoom,
  setZoom,
  demarcation,
  setDemarcation,
  avatar,
  setAvatar,
  equipment,
  setEquipment,
  equipmentCollection,
  setEquipmentCollection,
  measures,
  setMeasures,
  measuresComputed,
  setMeasuresComputed,
  measuresAlerts,
  setMeasuresAlerts,
  thresholdsValues,
  setThresholdsValues,
  errors,
  setErrors,
  alertTimeRange,
  alertTimeMeasure,
  setAlertTimeRange,
  setAlertTimeMeasure,
  URL,
  setURL,
  zones,
  setZones,
  thresholdsRanges,
  setThresholdsRanges,
  objectMeasures,
  configData,
  equipmentTypes,
  assetMeasurands,
  setAssetMeasurands,
  assetExternalServices,
  setAssetExternalServices,
  assetAdditionalSensors,
  setAssetAdditionalSensors,
  assetExternalServicesCheck,
  setAssetExternalServicesCheck,
  assetExternalServicesFields,
  setAssetExternalServicesFields,
  setPolyline,
  polylineDisplay,
  setPolylineDisplay,
  setCentroid,
  edition,
  setEdition,
}) => {
  const intl = useIntl();
  const theme = useMemo(() => getMuiTheme(), []);
  const [equipmentOptions, setEquipmentOptions] = useState([""]);
  const [dobModal, setDobModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [dobFile, setDobFile] = useState(null);
  const [loading, setLoading] = useState(false);
  //const moduleOptions = ["thermic", "dam", "railway", "marine", "road", "intrusion"];
  const prevEquipmentCollection = useRef(equipmentCollection);
  const [showOldPassword, setShowOldPassword] = useState(false);

  //const [computing, setComputings] = useState([]);
  useMemo(() => {
    if (!isNil(equipmentTypes)) {
      const newEquipmentTypes = [];
      for (let indexType = 0; indexType < equipmentTypes.length; indexType++) {
        newEquipmentTypes.push(equipmentTypes[indexType].name);
      }
      setEquipmentOptions(newEquipmentTypes);
    }
  }, [equipmentTypes]);

  useEffect(() => {
    if (assetName.length < 3) {
      setErrors((prevErrors) => ({ ...prevErrors, "asset-name": "3.characters" }));
    } else {
      setErrors((prevErrors) => {
        const { "asset-name": assetName, ...restErrors } = prevErrors;
        return restErrors;
      });
    }
  }, [assetName, setErrors]);

  useEffect(() => {
    if (prevEquipmentCollection.current !== equipmentCollection) {
      manageMeasures({
        equipmentCollection,
        setEquipmentCollection,
        equipment,
        setEquipment,
        thresholdsValues,
        setThresholdsValues,
        measures,
        setMeasures,
        measuresComputed,
        setMeasuresComputed,
        measuresAlerts,
        setMeasuresAlerts,
        objectMeasures,
        zones,
        setZones,
        thresholdsRanges,
        setThresholdsRanges,
      });
      prevEquipmentCollection.current = equipmentCollection;

      if (!isEmpty(assetExternalServices)) {
        const stillValidServices = assetExternalServices.filter((service) =>
          equipmentCollection.some((type) => service.equipmentTypesAllowed?.includes(type)),
        );

        if (stillValidServices.length !== assetExternalServices.length) {
          setAssetExternalServices(stillValidServices);
          setAssetExternalServicesFields(stillValidServices);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentCollection]);

  return (
    <div style={{ width: "100%", height: "100%", overflowX: "hidden" }} key={"assetInfoForm"}>
      <ThemeProvider theme={theme}>
        <Grid
          container
          spacing={10}
          direction="row"
          justifyContent="left"
          sx={{ marginLeft: "3.6rem" }}
          alignItems="flex-start"
        >
          <Grid item xs={10} sm={2}>
            <FormControl>
              <TextField
                autoFocus
                value={assetName}
                variant="outlined"
                autoComplete="off"
                margin="dense"
                id="asset-name"
                label={intl.formatMessage({ id: "name" })}
                type="text"
                fullWidth
                required
                error={errors["asset-name"] ? true : false}
                onChange={(e) => {
                  setAssetName(e.target.value);
                  let newEquipment = clone(equipment);
                  for (let index = 0; index < newEquipment.length; index++) {
                    newEquipment[index].asset = e.target.value;
                  }
                  setEquipment(newEquipment);
                }}
              ></TextField>
              {!isNil(errors["asset-name"]) && (
                <ErrorText>{intl.formatMessage({ id: errors["asset-name"] })}</ErrorText>
              )}
            </FormControl>
          </Grid>

          {/**
           * 
           *           <Grid item xs={10} sm={2}>
            <FormControl>
              <TextField
                autoFocus
                value={URL}
                variant="outlined"
                autoComplete="off"
                margin="dense"
                id="url"
                label={intl.formatMessage({ id: "url-microservice" })}
                type="text"
                fullWidth
                required
                error={errors["url"] ? true : false}
                onChange={(e) => {
                  setURL(e.target.value);
                }}
              ></TextField>
              {!isNil(errors["url"]) && <ErrorText>{intl.formatMessage({ id: errors["url"] })}</ErrorText>}
            </FormControl>
          </Grid><Grid item xs={10} sm={1}>
            <TextField
              id="zoom"
              margin="dense"
              style={{ width: "5rem" }}
              variant="outlined"
              value={zoom}
              onChange={(e) => setZoom(e.target.value)}
              label={"Zoom"}
              required
              type="number"
              inputProps={{ min: 0, max: 16 }}
            ></TextField>
          </Grid> */}
          <Grid item xs={10} sm={1}>
            <div style={{ marginTop: "10%" }}>
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                id="file-input"
                onChange={(event) => {
                  const file = event.target.files[0];
                  if (file && file.type.startsWith("image/")) {
                    const reader = new FileReader();
                    reader.onload = () => {
                      const base64String = reader.result;
                      setAvatar(base64String.split("base64,")?.[1]);
                    };
                    reader.readAsDataURL(file);
                  }
                }}
              />
              <label htmlFor="file-input">
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: avatar.length === 0 ? palette.primary : "#420d10",
                    color: avatar.length > 0 && "grey",
                  }}
                  component="span"
                >
                  upload image {avatar.length > 0 && <CheckIcon />}
                </Button>
              </label>
            </div>
          </Grid>
          {!isNil(configData) && !isNil(configData.demarcations) && !isEmpty(configData.demarcations) ? (
            <Grid item xs={12} sm={1.5}>
              <TextField
                id="demarcation"
                margin="dense"
                sx={{ width: "10rem" }}
                variant="outlined"
                value={demarcation}
                onChange={(e) => setDemarcation(e.target.value)}
                select
                label={intl.formatMessage({ id: "demarcation" })}
                required
              >
                {configData.demarcations.map((dem, demIndex) => {
                  return (
                    <MenuItem key={`dem_${dem}_${demIndex}`} value={dem}>
                      {dem}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
          ) : null}
          {/**          <Grid item xs={10} sm={3}>
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginLeft: "0.5rem" }}>
              <TextField
                id={"alert_time_range"}
                style={{ marginTop: "0.2rem" }}
                value={alertTimeRange}
                onChange={(e) => {
                  const newErrors = { ...errors };
                  if (isEmpty(e.target.value)) {
                    newErrors[e.target.id] = "not.empty";
                  } else {
                    delete newErrors[e.target.id];
                  }
                  setErrors(newErrors);
                  setAlertTimeRange(e.target.value);
                }}
                type="number"
                variant="outlined"
                error={errors["alert_time_range"] ? true : false}
                label={intl.formatMessage({ id: "alert.time.range" })}
                required
              ></TextField>
              {!isNil(errors["alert_time_range"]) && (
                <ErrorText>{intl.formatMessage({ id: errors["alert_time_range"] })}</ErrorText>
              )}
              <TextField
                id="alert_time_measure"
                margin="dense"
                style={{ width: "14rem" }}
                variant="outlined"
                value={alertTimeMeasure}
                defaultValue={1}
                error={errors["alert_time_measure"] ? true : false}
                onChange={(e) => {
                  setAlertTimeMeasure(parseInt(e.target.value));
                }}
                select
                label={intl.formatMessage({ id: "alert.time.measure" })}
                required
              >
                <MenuItem value={1}>{intl.formatMessage({ id: "hours" })}</MenuItem>
                <MenuItem value={24}>{intl.formatMessage({ id: "days" })}</MenuItem>
              </TextField>
            </div>
          </Grid> */}
        </Grid>
        <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", padding: "0 0.7rem" }}>
          <div style={{ fontSize: "large", marginTop: "0.5rem", width: "7rem" }}>
            <div style={{ minWidth: "10rem", margin: "2rem" }}>{intl.formatMessage({ id: "equipments" })}:</div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", margin: "0.5rem" }}>
            {equipmentCollection.map((et, index) => (
              <React.Fragment key={`equipment_${index}`}>
                <TextField
                  id={`type${index}`}
                  key={`type${index}`}
                  margin="dense"
                  style={{ width: "15rem" }}
                  variant="outlined"
                  value={et}
                  onChange={(e) => {
                    let newTypes = clone(equipmentCollection);
                    newTypes[index] = e.target.value;

                    let newMeasurands = [];

                    newTypes.forEach((typeName) => {
                      const typeData = equipmentTypes.find((et) => et.name === typeName);
                      if (typeData) {
                        if (typeData.measurands) {
                          typeData.measurands.forEach((msr) => {
                            if (!newMeasurands.some((existing) => existing === msr)) {
                              newMeasurands.push(msr);
                            }
                          });
                        }

                        //if (typeData.config?.modules) {
                        //  typeData.config.modules.forEach((mod) => {
                        //    if (!newModules.some((existing) => existing.name === mod.name)) {
                        //      newModules.push(mod);
                        //    }
                        //  });
                        //}
                      }
                    });
                    const polylineEquipments = [];
                    if (!isEmpty(polylineDisplay)) {
                      for (let indexPoly = 0; indexPoly < polylineDisplay.length; indexPoly++) {
                        polylineEquipments.push(polylineDisplay[indexPoly].equipment_type);
                      }
                    }

                    if (
                      equipmentCollection[index] !== newTypes[index] &&
                      equipmentCollection[index] !== "" &&
                      !polylineEquipments.includes(newTypes[index]) &&
                      !isEmpty(polylineDisplay) &&
                      !isEmpty(equipment)
                    ) {
                      setEquipment([]);
                      setPolyline([]);
                      setPolylineDisplay([]);
                      setCentroid([]);
                      toast.info(intl.formatMessage({ id: "polyline.equipment.deleted" }), { className: "toast-info" });
                    }
                    setAssetMeasurands(newMeasurands);
                    setEquipmentCollection(newTypes);
                    const newErrors = { ...errors };
                    if (newTypes.length !== equipment.length) {
                      newErrors["saveButton"] = "no.coincidence.equipments";
                    } else {
                      delete newErrors["saveButton"];
                    }
                    setErrors(newErrors);
                  }}
                  select
                  label={intl.formatMessage({ id: "select.type.equipment" })}
                  required
                >
                  {equipmentOptions.map((eo, index2) => (
                    <MenuItem value={eo} key={`eo_${index}_${index2}`}>
                      {eo}
                    </MenuItem>
                  ))}
                </TextField>
              </React.Fragment>
            ))}
          </div>

          <div style={{ display: "flex", alignItems: "center" }}>
            {equipmentCollection.length < 6 && (
              <IconButton
                style={{ backgroundColor: palette.dividerLight }}
                onClick={() => {
                  setEquipmentCollection((et) => [...et, ""]);
                  //let newZones = clone(zones);
                  //newZones[`equipment${equipmentCollection.length + 1}`] = {
                  //  channel1: {
                  //    sub1: [{ ini: 0, end: 10, alertsConfigurations: null }],
                  //  },
                  //};
                  setEdition(false);
                  //setZones(newZones);
                }}
              >
                <AddIcon sx={{ color: palette.primary }} />
              </IconButton>
            )}
            {equipmentCollection.length > 1 && (
              <DeleteForeverIcon
                onClick={() => {
                  const newET = clone(equipmentCollection);
                  const equipmentData = equipmentTypes.find(
                    (et) => equipmentCollection[equipmentCollection.length - 1] === et.name,
                  );
                  if (!isNil(equipmentData)) {
                    // const actualModules = configData.modules;
                    const actualMeasurands = equipmentData.measurands;
                    let newMeasurands = clone(assetMeasurands);
                    //let newModules = clone(assetModules);

                    // Suponiendo que la propiedad única es `ref`
                    //const key = "ref";
                    //const key2 = "name";

                    //const makeKeySet = (arr, key) => new Set(arr.map((item) => item?.[key]).filter(Boolean));
                    //const makeKeySet2 = (arr, key) => new Set(arr.map((item) => item?.[key]).filter(Boolean));

                    //const actualModulesSet = makeKeySet2(actualModules, key2);
                    //const actualMeasurandsSet = makeKeySet(actualMeasurands, key);

                    //newModules = newModules.filter((m) => !actualModulesSet.has(m?.[key2]));
                    //newMeasurands = newMeasurands.filter((m) => !actualMeasurandsSet.has(m?.[key]));
                    const makeSet = (arr) => new Set(arr.filter(Boolean)); // crea un set de valores únicos

                    const actualMeasurandsSet = makeSet(actualMeasurands);

                    newMeasurands = newMeasurands.filter((m) => !actualMeasurandsSet.has(m));
                    setAssetMeasurands(newMeasurands);
                    //setAssetModules(newModules);
                  }
                  newET.splice(newET.length - 1, 1);
                  const newErrors = { ...errors };
                  if (newET.length !== equipment.length) {
                    newErrors["saveButton"] = "no.coincidence.equipments";
                  } else {
                    delete newErrors["saveButton"];
                  }
                  setErrors(newErrors);
                  setEdition(false);
                  setEquipmentCollection(newET);
                  let newZones = clone(zones);
                  delete newZones[`equipment${equipmentCollection.length}`];
                  setZones(newZones);
                }}
                sx={{ color: palette.primary, cursor: "pointer" }}
              />
            )}
          </div>
        </div>
        <div style={{ display: "inline-block", marginLeft: "8.7rem" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: palette.primary,
                  "&.Mui-checked": {
                    color: palette.primary,
                  },
                }}
                checked={!isNil(assetAdditionalSensors)}
                onChange={(event) => {
                  if (event.target.checked) {
                    setAssetAdditionalSensors({
                      sensors: [],
                      measurands: [],
                      active: false,
                    });
                  } else {
                    setAssetAdditionalSensors(null);
                  }
                }}
              />
            }
            label={intl.formatMessage({ id: "additional.sensors" })}
          />
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: palette.primary,
                  "&.Mui-checked": {
                    color: palette.primary,
                  },
                }}
                checked={assetExternalServicesCheck}
                onChange={(event) => {
                  setAssetExternalServicesCheck(event.target.checked);
                  if (!event.target.checked) {
                    setAssetExternalServices([]);
                    setAssetExternalServicesFields([]);
                  }
                }}
              />
            }
            label={intl.formatMessage({ id: "external.services" })}
          />
          {equipmentCollection[0] !== "" &&
            !isNil(equipmentTypes) &&
            (() => {
              const measurandOptions = [];
              //const moduleOptions = [];
              for (let indexColletion = 0; indexColletion < equipmentCollection.length; indexColletion++) {
                const equipmentType = equipmentCollection[indexColletion];
                if (equipmentType !== "") {
                  const equipmentData = equipmentTypes.find((et) => equipmentType === et.name);
                  //for (let indexModule = 0; indexModule < configData.modules.length; indexModule++) {
                  //  if (!moduleOptions.some((opt) => opt.name === configData.modules[indexModule].name))
                  //    moduleOptions.push(configData.modules[indexModule]);
                  //}
                  for (let indexMeasurand = 0; indexMeasurand < equipmentData.measurands.length; indexMeasurand++) {
                    if (!measurandOptions.includes(equipmentData.measurands[indexMeasurand])) {
                      measurandOptions.push(equipmentData.measurands[indexMeasurand]);
                    }
                  }
                }
              }

              return (
                <>
                  <Autocomplete
                    multiple
                    id="measurand_select"
                    variant="outlined"
                    options={measurandOptions}
                    value={assetMeasurands}
                    disabled={true}
                    isOptionEqualToValue={(option, value) => option === value}
                    sx={{
                      width: "16rem", // aumenta el ancho para que quepan más chips
                      ".MuiChip-root": {
                        maxWidth: "100%", // permite que los chips no se corten
                      },
                      ".MuiAutocomplete-tag": {
                        maxWidth: "calc(100% - 16px)", // previene overflow
                      },
                      marginTop: "4%",
                    }}
                    disableCloseOnSelect
                    onChange={(event, values) => {
                      setAssetMeasurands(values);
                    }}
                    getOptionLabel={(option) => intl.formatMessage({ id: option })}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox style={{ marginRight: 8 }} checked={selected} />
                        {intl.formatMessage({ id: option })}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" label={intl.formatMessage({ id: "measurands" })} />
                    )}
                    required
                  />
                  {/*<Autocomplete
                    multiple
                    id="module_select"
                    variant="outlined"
                    value={assetModules}
                    options={moduleOptions}
                    isOptionEqualToValue={(option, value) => option.name === value.name}
                    sx={{
                      width: "16rem", // aumenta el ancho para que quepan más chips
                      ".MuiChip-root": {
                        maxWidth: "100%", // permite que los chips no se corten
                      },
                      ".MuiAutocomplete-tag": {
                        maxWidth: "calc(100% - 16px)", // previene overflow
                      },
                      marginTop: "4%",
                    }}
                    disableCloseOnSelect
                    onChange={(event, values) => {
                      for (let indexValue = 0; indexValue < values.length; indexValue++) {
                        const actualModule = configData.modules.find(
                          (module) => module.name === values[indexValue].name,
                        );
                        const inclinometersFound = actualModule.packages.find((pack) => pack.name === "inclinometers");

                        if (inclinometersFound) {
                          setMoreSubsAllowed(true);
                          break;
                        }
                        setMoreSubsAllowed(false);
                      }
                      setAssetModules(values);
                    }}
                    getOptionLabel={(option) => intl.formatMessage({ id: option.name })}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox style={{ marginRight: 8 }} checked={selected} />
                        {intl.formatMessage({ id: option.name })}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" label={intl.formatMessage({ id: "modules" })} />
                    )}
                    required
                  />*/}
                </>
              );
            })()}
          {assetExternalServicesCheck &&
            !isNil(configData) &&
            !isNil(configData.externalServices) &&
            (() => {
              const serviceGroups = configData.externalServices;
              const serviceOptions = [];
              for (let indexGroup = 0; indexGroup < serviceGroups.length; indexGroup++) {
                const serviceGroup = serviceGroups[indexGroup];
                const hayCoincidencia = equipmentCollection.some((item) =>
                  serviceGroup.equipmentTypesAllowed.includes(item),
                );
                if (serviceGroups[indexGroup].contracted && hayCoincidencia) {
                  for (let indexService = 0; indexService < serviceGroups[indexGroup].services.length; indexService++) {
                    const service = serviceGroup.services[indexService];

                    if (service.active) {
                      // añadimos la categoría al propio objeto del servicio
                      serviceOptions.push({
                        ...service,
                        category: serviceGroup.category,
                        equipmentTypesAllowed: serviceGroup.equipmentTypesAllowed,
                      });
                    }
                  }
                }
              }
              if (isEmpty(serviceOptions)) {
                return null;
              }

              // IMPORTANTE: MUI Autocomplete necesita las opciones ordenadas por el campo de groupBy
              serviceOptions.sort((a, b) => a.category.localeCompare(b.category));

              return (
                <>
                  <Autocomplete
                    multiple
                    id="service_select"
                    variant="outlined"
                    value={assetExternalServicesFields}
                    options={serviceOptions}
                    groupBy={(option) => option.category}
                    sx={{
                      width: "16rem",
                      ".MuiChip-root": {
                        maxWidth: "100%",
                      },
                      ".MuiAutocomplete-tag": {
                        maxWidth: "calc(100% - 16px)",
                      },
                      marginTop: "4%",
                      marginBottom: "4%",
                    }}
                    disableCloseOnSelect
                    onChange={(event, values) => {
                      let newServicesValues = clone(assetExternalServices ?? []);

                      newServicesValues = newServicesValues.filter((sv) => values.some((v) => v.name === sv.name));

                      for (const service of values) {
                        const auxConfigForm = service.configForm.map((field) => {
                          const existingService = newServicesValues.find((sv) => sv.name === service.name);
                          const existingField = existingService?.configForm?.find((f) => f.name === field.name);

                          let newObject = clone(field);
                          newObject.ref = field.name;
                          newObject.value =
                            existingField?.value ??
                            (["text", "mail", "password"].includes(field.type)
                              ? ""
                              : field.type === "number"
                                ? 0
                                : field.options[0]);

                          return newObject;
                        });

                        let auxFinalObject = clone(service);
                        auxFinalObject.configForm = auxConfigForm;

                        const index = newServicesValues.findIndex((sv) => sv.name === auxFinalObject.name);
                        if (index !== -1) {
                          newServicesValues[index] = auxFinalObject;
                        } else {
                          newServicesValues.push(auxFinalObject);
                        }
                      }

                      setAssetExternalServicesFields(newServicesValues);
                      setAssetExternalServices(newServicesValues);
                    }}
                    isOptionEqualToValue={(option, value) => option.ref === value.ref}
                    getOptionLabel={(option) => option.name}
                    renderGroup={(params) => (
                      <li key={params.key}>
                        <div
                          style={{
                            padding: "4px 10px",
                            fontWeight: 600,
                            fontSize: "0.8rem",
                            backgroundColor: palette.dividerLight,
                          }}
                        >
                          {intl.formatMessage({ id: params.group }) ?? params.group}
                        </div>
                        <ul style={{ padding: 0 }}>{params.children}</ul>
                      </li>
                    )}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox style={{ marginRight: 8 }} checked={selected} />
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label={intl.formatMessage({ id: "external.services" })}
                      />
                    )}
                    required
                  />
                </>
              );
            })()}
          {!isNil(assetExternalServices) &&
            !isEmpty(assetExternalServices) &&
            assetExternalServicesFields.map((aesf, aesfIndex) => {
              const elements = [];
              for (let index = 0; index < aesf.configForm.length; index++) {
                if (!aesf.configForm[index].required) continue; // OPCIONES: TEXT, NUMBER, MAIL, PASSWORD Y SELECT
                if (aesf.configForm[index].type === "text") {
                  elements.push(
                    <React.Fragment key={`${aesf.configForm[index].name}_${aesfIndex}`}>
                      <TextField
                        autoFocus
                        value={aesf.configForm[index].value}
                        variant="outlined"
                        autoComplete="off"
                        margin="dense"
                        id={aesf.configForm[index].name}
                        key={`${aesf.configForm[index].name}_${aesfIndex}`}
                        label={aesf.configForm[index].name.toUpperCase()}
                        type="text"
                        fullWidth
                        required
                        error={errors[aesf.configForm[index].name] ? true : false}
                        onChange={(e) => {
                          if (aesf.configForm[index].ref === "ip") {
                            const newErrors = { ...errors };
                            const regex =
                              /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                            const isValidInput = regex.test(e.target.value);
                            if (isEmpty(e.target.value)) {
                              newErrors[e.target.id] = "not.empty";
                            } else if (!isValidInput) {
                              newErrors[e.target.id] = "must.ip";
                            } else {
                              delete newErrors[e.target.id];
                            }
                            setErrors(newErrors);
                          }
                          let newServiceValues = clone(assetExternalServices);
                          let newIndex = assetExternalServices[aesfIndex].configForm.findIndex(
                            (aes) => aes.ref === aesf.configForm[index].name,
                          );
                          newServiceValues[aesfIndex].configForm[newIndex].value = e.target.value;
                          setAssetExternalServices(newServiceValues);
                          setAssetExternalServicesFields(newServiceValues);
                        }}
                      ></TextField>
                      {!isNil(errors[aesf.configForm[index].name]) && (
                        <ErrorText>{intl.formatMessage({ id: errors[aesf.configForm[index].name] })}</ErrorText>
                      )}
                    </React.Fragment>,
                  );
                }
                if (aesf.configForm[index].type === "number") {
                  elements.push(
                    <React.Fragment key={`${aesf.configForm[index].name}_${aesfIndex}`}>
                      <TextField
                        id={aesf.configForm[index].name}
                        key={`${aesf.configForm[index].name}_${aesfIndex}`}
                        style={{ margin: "0 0.2rem 0.8rem", width: "15rem" }}
                        value={aesf.configForm[index].value}
                        inputProps={{ min: 1 }}
                        onChange={(e) => {
                          let newServiceValues = clone(assetExternalServices);
                          let newIndex = assetExternalServices.findIndex(
                            (aes) => aes.ref === aesf.configForm[index].name,
                          );
                          newServiceValues[aesfIndex].configForm[newIndex].value = parseInt(e.target.value);
                          setAssetExternalServices(newServiceValues);
                          setAssetExternalServicesFields(newServiceValues);
                        }}
                        type="number"
                        error={errors[`sub_sectioncount_${0}`] ? true : false}
                        variant="outlined"
                        label={aesf.configForm[index].name.toUpperCase()}
                        required
                      ></TextField>
                    </React.Fragment>,
                  );
                }
                if (aesf.configForm[index].type === "mail") {
                  elements.push(
                    <React.Fragment key={`${aesf.configForm[index].name}_${aesfIndex}`}>
                      <InputLabel htmlFor={aesf.configForm[index].name}>
                        {intl.formatMessage({ id: "email" })}*
                      </InputLabel>
                      <OutlinedInput
                        id={aesf.configForm[index].name}
                        key={`${aesf.configForm[index].name}_${aesfIndex}`}
                        type="email"
                        required
                        autoComplete="off"
                        endAdornment={
                          <InputAdornment position="end">
                            <AlternateEmailIcon color="#e4e6ef" />
                          </InputAdornment>
                        }
                        label={`${intl.formatMessage({ id: "email" })}*`}
                        value={aesf.configForm[index].value}
                        onChange={(e) => {
                          let newServiceValues = clone(assetExternalServices);
                          let newIndex = assetExternalServices.findIndex(
                            (aes) => aes.ref === aesf.configForm[index].name,
                          );
                          newServiceValues[aesfIndex].configForm[newIndex].value = e.target.value;
                          const isValid = validateEmail(e.target.value);
                          const newErrors = { ...errors };
                          if (!isValid) {
                            newErrors[e.target.id] = "password.verification.error.message";
                          }
                          setErrors(!isValid ? newErrors : null);
                          setAssetExternalServices(newServiceValues);
                          setAssetExternalServicesFields(newServiceValues);
                        }}
                      />
                      {!isNil(errors[aesf.configForm[index].name]) && (
                        <ErrorText>{intl.formatMessage({ id: errors[aesf.configForm[index].name] })}</ErrorText>
                      )}
                    </React.Fragment>,
                  );
                }
                if (aesf.configForm[index].type === "password") {
                  elements.push(
                    <React.Fragment key={`${aesf.configForm[index].name}_${aesfIndex}`}>
                      <OutlinedInput
                        id="currentPassword"
                        type={showOldPassword ? "text" : "password"}
                        autoComplete="new-password"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="visibility"
                              onClick={() => setShowOldPassword(!showOldPassword)}
                              onMouseDown={(event) => event.preventDefault()}
                              edge="end"
                              data-testid={`user-profile-visibility`}
                            >
                              {showOldPassword ? <VisibilityOff color="#e4e6ef" /> : <Visibility color="#e4e6ef" />}
                            </IconButton>
                          </InputAdornment>
                        }
                        label={`${intl.formatMessage({ id: "current password" })}*`}
                        key={`${aesf.configForm[index].name}_${aesfIndex}`}
                        value={aesf.configForm[index].value}
                        onChange={(e) => {
                          let newServiceValues = clone(assetExternalServices);
                          let newIndex = assetExternalServices.findIndex(
                            (aes) => aes.ref === aesf.configForm[index].name,
                          );
                          newServiceValues[aesfIndex].configForm[newIndex].value = e.target.value;
                          const isValid = validatePassword(e.target.value);
                          const newErrors = { ...errors };
                          if (!isValid) {
                            newErrors[e.target.id] = "password.verification.error.message";
                          }
                          setErrors(!isValid ? newErrors : null);
                          setAssetExternalServices(newServiceValues);
                          setAssetExternalServicesFields(newServiceValues);
                        }}
                      />
                      {!isNil(errors[aesf.configForm[index].name]) && (
                        <ErrorText>{intl.formatMessage({ id: errors[aesf.configForm[index].name] })}</ErrorText>
                      )}
                    </React.Fragment>,
                  );
                }
                if (aesf.configForm[index].type === "select") {
                  elements.push(
                    <React.Fragment key={`${aesf.configForm[index].name}_${aesfIndex}`}>
                      <TextField
                        id={`type${index}`}
                        key={`${aesf.configForm[index].name}_${aesfIndex}`}
                        margin="dense"
                        style={{ width: "15rem" }}
                        variant="outlined"
                        value={aesf.configForm[index].value}
                        onChange={(e) => {
                          let newServiceValues = clone(assetExternalServices);
                          let newIndex = assetExternalServices.findIndex(
                            (aes) => aes.ref === aesf.configForm[index].name,
                          );
                          newServiceValues[aesfIndex].configForm[newIndex].value = e.target.value;
                          setAssetExternalServices(newServiceValues);
                          setAssetExternalServicesFields(newServiceValues);
                        }}
                        select
                        label={aesf.configForm[index].name.toUpperCase()}
                        required
                      >
                        {aesf.configForm[index].options.map((opt, index2) => (
                          <MenuItem key={`${aesf.configForm[index].name}_opt_${index2}`} value={opt}>
                            {opt}
                          </MenuItem>
                        ))}
                      </TextField>
                    </React.Fragment>,
                  );
                }
              }

              if (elements.length === 0) return null;
              return (
                <Box key={`group_${aesfIndex}`} sx={{ mb: 2 }}>
                  <Typography key={`group_${aesfIndex}_${aesf.name}`} variant="h5" sx={{ mb: 1 }}>
                    {aesf.name}
                  </Typography>

                  {elements}
                </Box>
              );
            })}
        </div>
        {/*<div style={{ display: "inline-block", marginRight: "8.7rem" }}
          <ThemeProvider theme={theme}>
            <Dialog open={dobModal} onClose={() => setDobModal(false)}>
              <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
                {intl.formatMessage({ id: "add reading" })}
              </DialogTitle>
              <DialogContent style={{ paddingBottom: "0" }}>
                <form autoComplete="off">
                  <div>
                    <Divider style={{ marginBottom: "1rem", color: palette.primary }} />
                    <div style={{ width: "100%", height: "100%" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "baseline",
                          gap: "0.5rem",
                          padding: "1rem",
                        }}
                      >
                        <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              id="date_picker"
                              label={intl.formatMessage({ id: "date" })}
                              format="dd-MM-yyyy"
                              value={selectedDate}
                              shouldDisableDate={(date) => {
                                const formatted = format(date, "yyyy-MM-dd");
                                const today = startOfDay(new Date());

                                const isInvalidDob = dobDates.includes(formatted);
                                const isFuture = startOfDay(date) > today;

                                const shouldDisable = isInvalidDob || isFuture;

                                return shouldDisable;
                              }}
                              onChange={(e) => {
                                setSelectedDate(e);
                              }}
                            />
                          </LocalizationProvider>
                          <input
                            type="file"
                            accept=".csv, .json"
                            style={{ display: "none" }}
                            id="file-input"
                            onChange={(event) => {
                              setDobFile(event.target.files[0]);
                            }}
                          />
                          <label htmlFor="file-input">
                            <Button variant="contained" component="span">
                              {intl.formatMessage({ id: "upload.file" })}
                            </Button>
                          </label>
                        </div>
                      </div>
                    </div>
                    <Divider style={{ marginTop: "1rem" }} />
                  </div>
                </form>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  style={{ backgroundColor: palette.secondary, color: "white" }}
                  onClick={() => {
                    setDobModal(false);
                  }}
                >
                  {intl.formatMessage({ id: "cancel" })}
                </Button>
                <LoadingButton
                  variant="contained"
                  loading={loading ?? false}
                  style={{
                    backgroundColor: loading ? palette.light : palette.primary,
                    color: "white",
                  }}
                  onClick={async () => {
                    //handleModalAccept(date, time, modalChannel, modalSub);
                    const date = new Date(selectedDate);
                    const year = date.getFullYear();
                    const month = ("0" + (date.getMonth() + 1)).slice(-2);
                    const day = ("0" + date.getDate()).slice(-2);

                    const formattedDate = year + "-" + month + "-" + day;
                    //loadDoBfile({ channel, data: allData, event: dobFile, measurandsFiltered, setData });
                    const data = {
                      asset: assetName,
                      equipmentID: equipment,
                      substructure: substructure.ref,
                      module: assetModule,
                      package: measureName,
                      dateTime: formattedDate,
                    };
                    console.log(data);
                    const response = await postDoBData({ data, file: dobFile, intl });
                    if (response?.status === 200) {
                      let newDobDates = clone(dobDates);
                      newDobDates.push(formattedDate);
                      setDobDates(newDobDates);
                      loadDoBfile({
                        channel,
                        data: allData,
                        event: dobFile,
                        measurandsFiltered,
                        setData,
                        date: formattedDate,
                      });
                    }
                    setDobModal(false);
                  }}
                >
                  {intl.formatMessage({ id: "accept" })}
                </LoadingButton>
              </DialogActions>
            </Dialog>
          </ThemeProvider>
        </div>*/}
      </ThemeProvider>
    </div>
  );
};

export default AssetInfoForm;
